export default __webpack_public_path__ + "static/media/cards_flips_8.27e8aa57.mp3";